export default __webpack_public_path__ + "scene04cfd751.jpg";